// extracted by mini-css-extract-plugin
export default {"container":"aaa-z","tab":"baa-z","selected":"caa-z"};